export default __webpack_public_path__ + "static/media/FrutigerLTW02-55Roman.9ff99729.woff";